export default "__VITE_ASSET__DX1xXrnr__"